import {
  PRINT_STYLES_ALL,
  PRINT_STYLES_PIXEL,
  CAPABILITY_FONT_EFFECT_ANGLE,
  CAPABILITY_FONT_EFFECT_COLOR
} from '../../../../utils/constants';

export default {
  fonts: {},
  colors: {},
  effects: {
    1: {
      id: 1,
      name: 'Normal',
      image: 'normal',
      config: {},
      capabilities: PRINT_STYLES_ALL
    },
    2: {
      id: 2,
      name: 'Hard Shadow',
      image: 'shadow',
      config: {},
      capabilities: [...PRINT_STYLES_PIXEL, CAPABILITY_FONT_EFFECT_COLOR]
    },
    3: {
      id: 3,
      name: 'Outline Stroke',
      image: 'outline',
      config: {},
      capabilities: [...PRINT_STYLES_PIXEL, CAPABILITY_FONT_EFFECT_COLOR]
    },
    4: {
      id: 4,
      name: 'Circular',
      image: 'circle',
      config: {
        effectAngle: 320
      },
      capabilities: [...PRINT_STYLES_PIXEL, CAPABILITY_FONT_EFFECT_ANGLE]
    },
    5: {
      id: 5,
      name: 'Arched',
      image: 'arch',
      config: {
        effectAngle: 120
      },
      capabilities: [...PRINT_STYLES_PIXEL, CAPABILITY_FONT_EFFECT_ANGLE]
      // },
      // 6: {
      //   id: 6,
      //   name: 'Psychedelic',
      //   image: 'psychedelic',
      //   config: {},
      //   capabilities: [...PRINT_STYLES_PIXEL, CAPABILITY_FONT_EFFECT_COLOR]
    }
  }
};
